import AppHandler from 'stores/AppHandler';
import CardWallet from 'stores/CardWallet';

const useStores = () => ({
  AppHandler,
  CardWallet,
});

export default useStores;
